import { lazy } from "react";
const LoginPage = lazy(() => import("../views/PreLogin/Login"));
const ForgtPassword = lazy(() => import("../views/PreLogin/ForgotPasswordEmail"));
const SetNewPassword = lazy(() => import("../views/PreLogin/SetNewPassword"));
const ResetSuccessful = lazy(() => import("../views/PreLogin/ResetSuccessful"));

export const PreLoginRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgtPassword />,
  },
  {
    path: "/set-password",
    element: <SetNewPassword />,
  },
  {
    path: "/reset-successful",
    element: <ResetSuccessful />,
  },
];
